import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ssn'
})
export class SsnPipe implements PipeTransform {

    transform(value: any, mask: boolean = false): any {
        if (value == null) {
            return '';
        }else if (value.length !== 9) {
            return `Invalid SSN Number ${value}`;
        } else if(mask)
            return 'XXX-XX-' + value.substring(value.length - 4, value.length);
        else
            return value.substring(0, 3) + '-' + value.substring(3, 5) + '-' + value.substring(value.length - 4, value.length);
    }
}
